import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import GenericSocialExpandContainer from 'containers/dashboards/social/GenericSocialExpandContainer';
import { generateCalloutComponents } from 'helpers/componentGenerators';
import { validateCalloutData } from 'helpers/validate';
import { LAYERTHREE } from 'constants/layers';

const calloutSettings = [
    {
        key: 'impressions',
        title: 'Impressions',
        format: '0,0'
    },
    {
        key: 'engagements',
        title: 'Engagements',
        format: '0,0'
    },
    {
        key: 'conversions',
        title: 'Conversions',
        format: '0,0',
        validation: {
            fxn: validateCalloutData,
            passedArgs: { threshold: 0 }
        }
    }
];

class GenericSocialModule extends Component {
    render() {
        const { objective, layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social-generic-${objective}`;
        const { callouts, actions, campaigns } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', false);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutsData = hasCalloutData ? callouts.data : {};

        const calloutComponents = generateCalloutComponents({
            stub,
            calloutSettings,
            hasCalloutData,
            callouts: {
                ...calloutsData, completeData
            },
            calloutWindow
        });

        return (
            <ObjectiveVisibilityContainer objective={objective}
                actions={actions} layer={layer} campaigns={campaigns} expandContainer={GenericSocialExpandContainer}>
                {/* Call Outs */}
                <Row>
                    {calloutComponents}
                </Row>
            </ObjectiveVisibilityContainer>
        );
    }
}

GenericSocialModule.propTypes = {
    module: PropTypes.shape({
        callouts: PropTypes.object,
    }).isRequired
};

export default GenericSocialModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/GenericSocialModule.js